/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState } from "react";
// react-router-dom components
import { useSearchParams } from "react-router-dom";
import logoLight from "../../assets/images/buyers-club.png";
import { Card, Slider, Box, Typography } from "@mui/material";
import { getSubscriptionFrequencies, getStripeSubscriptions } from "../../apiCalls/caller";
import { Button, Col, Container, Row, Spinner, Modal, ModalBody } from "reactstrap";
import { toast } from "react-toastify";

/*eslint-disable*/
function Subscription() {
  const [value, setValue] = useState(0);
  const [searchParams] = useSearchParams();
  const [showSlider, setShowSlider] = useState(true);
  const [acconuntsData, setAcconuntsData] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [pricingMarks, setPricingMarks] = useState();
  const [maxValue, setMaxValue] = useState(200);
  const [user_token] = useState(searchParams.get("token"));
  const [user_freeTrials] = useState(searchParams.get("ftdays"));
  const [availableFrequencies, setAvailableFrequencies] = useState([]);
  const [loadingFrequencies, setLoadingFrequencies] = useState(true);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(true);
  const [error, setError] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const toggleTermsModal = () => setTermsModalOpen((prev) => !prev);

  const getFrequencies = async () => {
    try {
      setLoadingFrequencies(true);
      const response = await getSubscriptionFrequencies();
      
      if (response?.data) {
        // Filter only active frequencies
        const activeFrequencies = response.data.filter(
          (freq) => freq.sfr_status === 1
        );
        setAvailableFrequencies(activeFrequencies);
        
        if (activeFrequencies.length === 0) {
          setError("No subscription plans are currently available. Please contact support.");
          toast.error("No subscription plans available", { position: "top-center" });
        }
      } else {
        setError("Unable to load subscription options.");
        toast.error("Failed to load subscription options", { position: "top-center" });
      }
    } catch (err) {
      console.error("Error fetching frequencies:", err);
      setError("Unable to load subscription options. Please try again later.");
      toast.error("Failed to load subscription options", { position: "top-center" });
    } finally {
      setLoadingFrequencies(false);
    }
  };

  const getData = async () => {
    try {
      setLoadingSubscriptions(true);
      const response = await getStripeSubscriptions(user_token);
      
      // Combinar registros del mismo producto que tienen diferentes frecuencias
      const mergedData = {};
      response.forEach((item) => {
        const key = `${item.product_id}_${item.contacts || 'default'}`;
        
        if (!mergedData[key]) {
          mergedData[key] = { ...item };
        } else {
          // Combinar precios monthly y annual del mismo producto
          if (item.monthly && item.monthly > 0) {
            mergedData[key].monthly = item.monthly;
            mergedData[key].monthly_discount = item.monthly_discount;
          }
          if (item.annual && item.annual > 0) {
            mergedData[key].annual = item.annual;
            mergedData[key].annual_discount = item.annual_discount;
          }
        }
      });

      const mergedArray = Object.values(mergedData);
      setAcconuntsData(mergedArray);
      
      let cntValue = 0;
      let arrContacts = [];

      let arrResponse = Array.from(
        new Set(mergedArray.map((item) => item.contacts))
      );

      arrResponse.map(
        (item) => (
          arrContacts.push({
            value: cntValue,
            scaledValue: item,
            label: numFormatter(item),
          }),
          (cntValue += 25)
        )
      );

      if (mergedArray.length == 2) {
        setShowSlider(false);
      }

      const discount = mergedArray.filter((item) => item.monthly_discount && item.monthly_discount > 0);

      if (discount.length > 0) {
        setSelectedPlan(discount[0]);
        setShowSlider(false);
      }

      cntValue -= 25;
      setMaxValue(cntValue);
      setPricingMarks(arrContacts);
    } catch (err) {
      console.error("Error fetching subscriptions:", err);
      setError("Unable to load subscription plans. Please try again later.");
      toast.error("Failed to load subscription plans", { position: "top-center" });
    } finally {
      setLoadingSubscriptions(false);
    }
  };

  useEffect(() => {
    getFrequencies();
    getData();
  }, []);

  useEffect(() => {
    setSelectedPlan(
      acconuntsData.filter(
        (data) =>
          data.contacts ===
          pricingMarks.filter((item) => item.value === 0)[0].scaledValue
      )
    );
  }, [pricingMarks]);

  useEffect(() => {
    setSelectedPlan(
      acconuntsData.filter(
        (data) =>
          data.contacts ===
          pricingMarks.filter((item) => item.value === value)[0].scaledValue
      )
    );
  }, [value]);

  const scale = (value) => {
    const previousMarkIndex = Math.floor(value / 25);
    const previousMark = pricingMarks[previousMarkIndex];
    const remainder = value % 25;
    if (remainder === 0) {
      return previousMark.scaledValue;
    }
    const nextMark = pricingMarks[previousMarkIndex + 1];
    const increment = (nextMark.scaledValue - previousMark.scaledValue) / 25;
    return remainder * increment + previousMark.scaledValue;
  };

  function numFormatter(num) {
    if (num > 999 && num < 1000000) {
      return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(0) + "M"; // convert to M for number from > 1 million
    } else if (num < 900) {
      return num; // if value < 1000, nothing to do
    }
  }

  const handleChange = (event, newValue) => {
    if (typeof newValue === "number") {
      setValue(newValue);
      setSelectedPlan(
        acconuntsData.filter(
          (data) =>
            data.contacts ===
            pricingMarks.filter((item) => item.value === newValue)[0]
              .scaledValue
        )
      );
    }
  };

  const onSubscribe = async (type) => {
    try {
      const frequency = type === "monthly" ? "monthly" : "yearly";
      const token = new URLSearchParams(window.location.search).get("token");
      const tokenParam = token ? `&token=${token}` : "";
      window.location.href = `/subscribe?frequency=${frequency}${tokenParam}`;
    } catch (err) {
      console.error("Error redirecting to subscribe:", err);
      toast.error("Failed to redirect. Please try again.", { position: "top-center" });
    }
  };

  const isFrequencyAvailable = (frequency) => {
    return availableFrequencies.some(
      (freq) => freq.sfr_frequency === frequency && freq.sfr_status === 1
    );
  };

  const loading = loadingFrequencies || loadingSubscriptions;

  return (
    <div className="auth-page-content">
      <Container>

        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="text-center mt-sm-5 mb-4 ">
              <div>
                <img src={logoLight} alt="" height="200" style={{display:"none"}} />
              </div>
            </div>
            <div className="text-center mt-sm-5 mb-4 ">
              <Typography variant="h4" fontWeight="bold" gutterBottom style={{ marginTop: '6rem' }}>
                Choose your Membership Plan
              </Typography>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} lg={8}>
            <ul className="pt-3">
              <li>Full time staff of Buyer's and Product Analysts</li>
              <li>Access to thousands of curated products that are updated daily</li>
              <li>No need to set up supplier accounts, we do the heavy lifting!</li>
              <li>Integration with Sellercloud ($1200 value) which allows for inventory management and fulfillment across 100's of sales channels.</li>
              <li>Automated process from product ordering to end customer fulfillment</li>
              <li>Weekly HOT list items that are fast selling!</li>
            </ul>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8}>
            {loading ? (
              <div className="text-center mt-sm-2 mb-4">
                <Spinner color="primary" size="lg" />
                <Typography variant="body1" mt={2}>
                  Loading subscription options...
                </Typography>
              </div>
            ) : error ? (
              <div className="text-center mt-sm-2 mb-4">
                <Typography variant="h6" color="error" gutterBottom>
                  {error}
                </Typography>
                <Button
                  color="primary"
                  onClick={() => {
                    getFrequencies();
                    getData();
                  }}
                >
                  Retry
                </Button>
              </div>
            ) : (
            <div className="text-center mt-sm-2 mb-4 ">
              
              {showSlider && pricingMarks && pricingMarks.length > 1 && setSelectedPlan && (
                <Box p={3}>
                <Slider
                  value={value}
                  min={0}
                  step={25}
                  max={maxValue}
                  valueLabelFormat={numFormatter}
                  marks={pricingMarks}
                  scale={scale}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  aria-labelledby="non-linear-slider"
                />
                </Box>
              )}

              <div className="d-flex justify-content-space-between ">
                {isFrequencyAvailable("monthly") && (
                <Card variant="outlined" style={{ width: "100%" }}>
                  <Box p={3} textAlign="center">
                    <Typography variant="h5" fontWeight="medium">
                      Monthly
                    </Typography>
                    <Typography
                      variant="h3"
                      fontWeight="bold"
                      style={{
                        textDecoration:
                          selectedPlan.length > 0 &&
                          selectedPlan[0]?.monthly_discount &&
                          selectedPlan[0].monthly_discount !== 0
                            ? "line-through"
                            : "none",
                      }}
                    >
                      {selectedPlan.length > 0 &&
                        selectedPlan[0]?.monthly &&
                        "$" +
                          selectedPlan[0].monthly /
                            100}
                    </Typography>
                    {selectedPlan.length > 0 &&
                      selectedPlan[0]?.monthly_discount &&
                      selectedPlan[0].monthly_discount !== 0 && (
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="success"
                        >
                          {"$" +
                            selectedPlan[0].monthly_discount /
                              100}
                        </Typography>
                      )}
                    <Typography variant="body1" color="textSecondary" mt={2}>
                      $2988 annualy
                    </Typography>

                    <Typography variant="body2" color="textSecondary" mt={2}>
                      Enterprise support
                    </Typography>
                    <Box mt={3}>
                      <Button
                        color="success"
                        className="btn w-100"
                        disabled={!termsAccepted}
                        onClick={() => onSubscribe("monthly")}
                      >
                        {user_freeTrials > 0
                          ? user_freeTrials + "-days Free trial"
                          : "Subscribe"}
                      </Button>
                    </Box>
                  </Box>
                </Card>
                )}
                {isFrequencyAvailable("yearly") && (
                <Card variant="outlined" style={{ width: "100%" }}>
                  <Box p={3} textAlign="center">
                    <Typography variant="h5" fontWeight="medium">
                      Yearly
                    </Typography>
                    <Typography
                      variant="h3"
                      fontWeight="bold"
                      style={{
                        textDecoration:
                          selectedPlan.length > 0 &&
                          selectedPlan[0]?.annual_discount &&
                          selectedPlan[0].annual_discount !== 0
                            ? "line-through"
                            : "none",
                      }}
                    >
                      {selectedPlan.length > 0 &&
                        selectedPlan[0]?.annual &&
                        "$" +
                          selectedPlan[0].annual /
                            100}
                    </Typography>
                    {selectedPlan.length > 0 &&
                      selectedPlan[0]?.annual_discount &&
                      selectedPlan[0].annual_discount !== 0 && (
                        <Typography
                          variant="h4"
                          fontWeight="bold"
                          color="success"
                        >
                          {"$" +
                            selectedPlan[0].annual_discount /
                              100}
                        </Typography>
                      )}
                    <Typography variant="body1" color="textSecondary" mt={2}>
                      this is a savings of $1008 a year
                    </Typography>
                    <Typography variant="body2" color="textSecondary" mt={2}>
                      Enterprise support
                    </Typography>
                    <Box mt={3}>
                      <Button
                        color="success"
                        className="btn w-100"
                        disabled={!termsAccepted}
                        onClick={() => onSubscribe("annual")}
                      >
                        {user_freeTrials > 0
                          ? user_freeTrials + "-days Free trial"
                          : "Subscribe"}
                      </Button>
                    </Box>
                  </Box>
                </Card>
                )}
              </div>

              <div className="text-center mt-4">
                <div className="form-check d-inline-flex align-items-center gap-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="terms-accept"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="terms-accept">
                    I have read and agree to the{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleTermsModal();
                      }}
                    >
                      Terms and Conditions
                    </a>
                  </label>
                </div>
              </div>

              <Modal isOpen={termsModalOpen} toggle={toggleTermsModal} centered size="xl">
                <ModalBody style={{ height: "70vh", padding: 0, overflow: "hidden" }}>
                  {termsModalOpen && (
                    <div style={{ height: "100%", overflow: "hidden" }}>
                      <iframe
                        src="https://mybuyersclub.net/terms-and-conditions.html"
                        title="Terms and Conditions"
                        style={{ width: "100%", height: "calc(100% + 100px)", border: "none", marginTop: -100 }}
                      />
                    </div>
                  )}
                </ModalBody>
              </Modal>
            </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Subscription;
